var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256","fill":"currentColor","width":_vm.size,"height":_vm.size,"aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }